// extracted by mini-css-extract-plugin
export default {"Error":"Error401_Error__Knuhq"};